import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { PrivacyService } from './privacy.service';

export function provideDfModulePrivacy(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(PrivacyService).appInitialize();
        })
    ]);
}
